module.exports = __webpack_public_path__ + "img/macro_Off.fc428851.png";